import {createSlice} from "@reduxjs/toolkit";
import {fetchComponents} from "./componentsRepoThunks";

export const componentsRepoSlice = createSlice({
    name: 'componentsRepo',
    initialState: {
        componentsRepo: [],
        loading: true,
        error: null,

    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchComponents.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchComponents.fulfilled, (state, action) => {
                state.loading = false;
                state.componentsRepo = action.payload;
            })
            .addCase(fetchComponents.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            });

    }
});

export default componentsRepoSlice.reducer;